import { render } from "./Inputparams.vue?vue&type=template&id=94f0980a"
import script from "./Inputparams.vue?vue&type=script&lang=js"
export * from "./Inputparams.vue?vue&type=script&lang=js"

import "./Inputparams.vue?vue&type=style&index=0&id=94f0980a&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__